import * as React from "react";
const SvgDiagonalLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 49, viewBox: "0 0 28 49", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M0.435547 48.2451L27.4355 0.245117", stroke: "#0C233C" }));
export default SvgDiagonalLine;
